<template>
  <div class="catalogue">
    <div class="header-tool">
      <div class="header-tool-info">
        <div style="display: flex; align-items: center">
          <Breadcrumb>
            <BreadcrumbItem>参展</BreadcrumbItem>
            <BreadcrumbItem>车证申请</BreadcrumbItem>
          </Breadcrumb>
          <!-- 2026-08-20 修改：按要求去掉车证申请顶部文字（原代码注释保留，后续可能需要恢复） -->
          <!-- <p style="margin-left: 20px; font-size: 20px; color: red">
          {{ textEnd }}
          </p> -->
        </div>

        <div class="header-tool-title">{{ exhibition.name }}</div>
      </div>
      <div class="header-tool-box">
        <!-- 2026-08-27 修改：车证暂未开始，点击提示“暂未开始，敬请期待”（不再打开添加弹窗） -->
        <div class="htb-item" @click="$Message.warning('暂未开始，敬请期待')">
          <span class="htb-add">+</span>
          <span>添加车证</span>
        </div>
      </div>
    </div>
    <div class="header-tabs">
      <Tabs :animated="false" @on-click="switchBrand" v-model="showTabs">
        <TabPane label="已确认" name="1">
          <exhibitionCarYes
            ref="newCarNo"
            :addShow="addShow"
            @closeModal="
              addShow = false;
              showTabs = '1';
            "
            v-if="String(showTabs) === '1'"
          ></exhibitionCarYes>
        </TabPane>
        <TabPane label="未审核" name="2">
          <exhibitionCarNo
            :addShow="addShow"
            @closeModal="
              addShow = false;
              showTabs = '1';
              newCarYesList();
            "
            v-if="String(showTabs) === '2'"
          ></exhibitionCarNo>
        </TabPane>
      </Tabs>
    </div>

    <div class="catalogue-content"></div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import exhibitionCarYes from "./components/exhibition-car-yes";
import exhibitionCarNo from "./components/exhibition-car-no";

export default {
  name: "exhibition-info-carApply",
  data() {
      return {
          textEnd: '',
      addShow: false,
      showTabs: "1",
    };
  },
  components: {
    exhibitionCarYes,
    exhibitionCarNo,
  },
  computed: {
    ...mapGetters({
      exhibition: "loginModule/getExhibition",
    }),
  },
  created() {
    document.title = "中国国际医疗器械博览会 - 车证申请";

      // 2026-08-20 修改：顶部文字已去掉，这段截止时间判断注释掉（代码保留，后续可能需要恢复）
      // const deadline = new Date(2026, 3, 12, 17, 0, 0);
      // this.textEnd =
      //   Date.now() > deadline.getTime()
      //     ? "车证申请已截至"
      //     : "2026年4月12日17:00截止";
  },
  methods: {
    switchBrand(name) {
      // if (name === "1") {
      //   this.$router.push(`${this.$route.path}?type=all`);
      // } else if (name === "2") {
      //   this.$router.push(`${this.$route.path}?type=mes`);
      // } else if (name === "3") {
      //   this.$router.push(`${this.$route.path}?type=apply`);
      // }
    },

    newCarYesList() {
      setTimeout(() => {
        this.$refs["newCarNo"].getCarList();
      }, 1000);
    },
  },
};
</script>

<style scoped lang="scss">
.catalogue {
  .header-tool {
    min-height: 90px;
  }
  &-content {
    min-width: 1000px;
    margin: 24px;
    padding: 40px;
    min-height: 500px;
    padding-bottom: 190px;
  }
}
</style>
